module.exports = __webpack_public_path__ + "img/bahrain.c15967da.png";